export const clearAdminSessions = (currentUser) => {
  if (currentUser && currentUser.IsAdmin && window.location.href.indexOf('admin/admincentre') < 0) {
    sessionStorage.removeItem('SelectedPartner')
  }
}




// WEBPACK FOOTER //
// ./src/utils/clearSession.js